import type { EChartsCoreOption } from 'echarts/core'
import { formatAmount } from '@/utils/money.ts'

export function trendOption(
  labels: string[],
  series: { name: string; data: number[]; type?: 'bar' | 'line' }[],
  money = false
): EChartsCoreOption {
  return {
    grid: { left: '2%', right: '3%', top: '22%', bottom: '3%', containLabel: true },
    xAxis: {
      type: 'category',
      data: labels,
      boundaryGap: true,
      axisLabel: {
        formatter: (label: string) => (/^\d{4}-\d{2}-\d{2}$/.test(label) ? label.slice(5) : label),
        interval: labels.length <= 7 ? 0 : 'auto',
        showMinLabel: true,
        showMaxLabel: true,
        hideOverlap: labels.length > 7
      }
    },
    yAxis: {
      type: 'value',
      minInterval: money ? undefined : 1,
      name: money ? '元' : '数量',
      axisLabel: {
        show: true,
        hideOverlap: true,
        ...(money
          ? {
              formatter: (value: number) =>
                Math.abs(value) >= 10000 ? `${formatAmount(value / 10000)}万` : formatAmount(value)
            }
          : {})
      }
    },
    tooltip: money ? { valueFormatter: formatAmount } : undefined,
    series: series.map((item) => ({
      ...item,
      type: item.type ?? 'line',
      showSymbol: false,
      ...(item.type === 'bar'
        ? { barMaxWidth: 20, itemStyle: { borderRadius: [5, 5, 0, 0] } }
        : { smooth: 0.2, smoothMonotone: 'x', lineStyle: { width: 2.5 } }),
      emphasis: { focus: 'series' }
    }))
  }
}
